import React from 'react'
import { Button } from '@mui/material'
import * as S from './StartActionBody.style'
import { ButtonMui } from 'src/components/ButtonMui'

interface StartActionBodyProps {
  startActionButtonLabel: string
  cancelActionButtonLabel?: string
  startAction?: () => void,
  cancelAction?: () => void,
  actionTestId?: string,
  cancelTestId?: string,
  invoiceReturnList?: string[] | undefined,
  invoiceList?: string[],
  onClickCheckStatus?: () => void,
  verifyStatus: boolean
  hiddenCancelActionButton?: boolean
}

export const StartActionBody = ({
  startAction,
  cancelAction,
  startActionButtonLabel,
  cancelActionButtonLabel = 'Cancelar',
  actionTestId,
  cancelTestId,
  invoiceReturnList,
  invoiceList,
  onClickCheckStatus,
  verifyStatus,
  hiddenCancelActionButton = false,
}: StartActionBodyProps) => (
  <>
    <ButtonMui
      endIcon={<S.StartActionButtonIcon/>}
      bgColor='blue'
      hoverColor='darkBlueHover'
      letterColor='white'
      variant='contained'
      size='large'
      type='button'
      onClick={startAction}
      data-testid={actionTestId}
      title={startActionButtonLabel}
      disabled={verifyStatus}
    />
    {invoiceList && invoiceList.length > 0
    && (
    <>
      <strong>Notas fiscais:</strong>
      <S.Container>
        <ul>
          {invoiceList?.map((invoice) => (
            <S.Invoices>
              <li>{invoice}</li>
            </S.Invoices>
          ))}
        </ul>
      </S.Container>
    </>
    )}
    {invoiceReturnList && invoiceReturnList.length > 0
    && (
    <>
      <strong>Notas de devolução:</strong>
      <S.Container>
        <ul>
          {invoiceReturnList?.map((invoice) => (
            <S.Invoices>
              <li>{invoice}</li>
            </S.Invoices>
          ))}
        </ul>
      </S.Container>
    </>
    )}
    <S.ContainerButtons>
      {invoiceReturnList && invoiceReturnList.length > 0 && (
      <S.VerifyButton
        onClick={onClickCheckStatus}
        variant='contained'
        size='large'
        type='button'
        color='error'
        title='Vefificar'
        data-testid='verify-status-button'
      />
      )}
      <Button
        hidden={hiddenCancelActionButton}
        variant='contained'
        size='large'
        type='button'
        color='error'
        onClick={cancelAction}
        data-testid={cancelTestId}
      >
        {cancelActionButtonLabel}
      </Button>
    </S.ContainerButtons>
  </>
)
